<template>
  <v-card>
    <v-card-title primary-title class="justify-center">
      <div class="display-1 font-weight-medium blue--text text-xs-center">
        User Account Info
      </div>
    </v-card-title>  
    <v-card-text>
      <v-layout>
        <v-flex xs12>
          <p class="text-xs-center">
            <img :src="qr" width="100px" />
          </p>
        </v-flex>
      </v-layout>
      <v-layout v-for="(item, i) in infoLabel" :key="i">
        <v-flex xs3>
          <v-subheader>
            {{ item.label }}
          </v-subheader>
        </v-flex>
        <v-flex xs7>
          <v-text-field
          v-model="info[item.name]"
          outline
          readonly
          single-line
          ></v-text-field>
        </v-flex>
        <v-flex xs2 v-if="item.copy">
          <v-btn small class="mt-3" color="cyan" v-clipboard:copy="info[item.name]" v-clipboard:success="onCopySucc" v-clipboard:error="onCopyError">
            {{ $t('common.copy') }}
          </v-btn>
        </v-flex>
        <v-flex xs2 v-else-if="item.refresh">
          <v-btn icon small class="mt-3" @click="refreshWallet">
            <v-icon medium color="blue accent-4">
              refresh
            </v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout v-if="privKey !== null">
        <v-flex xs3>
          <v-subheader>
            {{ $t('common.info.priv_key') }}
          </v-subheader>
        </v-flex>
        <v-flex xs7>
          <v-text-field
            v-model="privKey"
            outline
            readonly
            single-line
            :type="showPriv ? 'text' : 'password'"
            :append-icon="showPriv ? 'visibility_off' : 'visibility'"
            @click:append="showPriv = !showPriv"
            ></v-text-field>
        </v-flex>
        <v-flex xs2>
          <v-btn small class="mt-3" color="cyan" v-show="showPriv" v-clipboard:copy="privKey" v-clipboard:success="onCopySucc" v-clipboard:error="onCopyError">
            {{ $t('common.copy') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs3>
          <v-subheader>
            Gas Management
          </v-subheader>
        </v-flex>
        <v-flex xs7 text-xs-center>
          <v-btn color="primary" @click="openPage('send')">
            Send Gas
            <v-icon right dark>call_made</v-icon>
          </v-btn>         
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>

  <v-card>
    <v-card-title>
      <span class="headline">Personal info</span>
    </v-card-title>
    <v-card-text>
      <v-layout>
        <v-flex xs12>
          <v-combobox
            v-model="userType"
            :items="userTypeItems"
            label="User Type"
            outline
            background-color="blue lighten-3"
          ></v-combobox>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            label="Full Name"
            v-model.trim="fullName"
            background-color="blue lighten-3"
            outline
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import qrcode from 'qrcode'

import webWallet from 'libs/web-wallet'

export default {
  data() {
    return {
      infoLabel: [
        { label: 'User ID', name: 'address', copy: true },
        { label: 'Gas Balance', name: 'balance', refresh: true },
        { label: 'Unconfirmed Balance', name: 'unconfirmedBalance' },
      ],
      wallet: webWallet.getWallet(),
      showPriv: false,
      qr: ''
    }
  },
  props: ['view'],
  watch: {
    view: function() {
      this.wallet.setInfo()
    }
  },
  computed: {
    info: function() {
      return this.wallet.info
    },
    privKey: function() {
      return this.wallet.getPrivKey()
    }
  },
  methods: {
    onCopySucc: function() {
      this.$root.success('copy success')
    },
    onCopyError: function() {
      this.$root.error('copy fail')
    },
    async refreshWallet(){
      this.wallet.setInfo()
    },
    openPage(name){
      this.$emit('openPage', name)
    },
    drawQrCode() {
      qrcode.toDataURL(this.info['address'], (err, url) => {
        this.qr = url
      })
    }
  },
  mounted: function() {
    this.drawQrCode()
  }
}
</script>



// WEBPACK FOOTER //
// src/controllers/View.vue